export default __webpack_public_path__ + "816a5786dfc90f3ae9e31117191f16bd.svg";